import { observable, action } from 'mobx'
import { News as Setting, Login, Common } from '@services/api'
import lodash from 'lodash'
import Store from 'store'
import { toLogin } from '@utils'
import signTrainApi from '@services/api/signTrain'
import { getHashRoute, directTo } from '@utils/url'
import { createHashHistory } from 'history'
import { transform } from '@utils/intl_lang'
import { getQueryParams } from '@utils/url'
import loginZhiniaoSilent from '@utils/SSOHelper'

type OperateType = {
  hasPermission: boolean
  id: string
  name: string
}

interface IOtherUsersInfo {
  userImg: string
  userName: string
  userId: string
}

interface ISessionInfo {
  appId: string
  enterpriseId: string
  enterpriseName: string
  sid: string
  userId: string,
  strOs: string
}

interface IUserInfo {
  isAgreeLive: string
  isFree: string
  isWlt: string
  nickName: string
  userImg: string
  userName: string
}
interface OtherUserInfo {
  inDate: string
  isBandOldEqxAccount: number
  isFirstSuccessLogin: number
  isInDateBfDesignTime: number
  isNeedBand: number
  isPost: number
  oldEqxAccount: string
}

export interface IUserStore {
  /** 登陆超时 */
  isLoginOverTimer: boolean
  /** isLogin */
  isLogin: boolean
  /** 用户昵称 */
  nickName: string
  /** 用户名称 */
  userName: string
  /** 用户头像 */
  avatar: string
  /** 企业id */
  enterpriseId: string
  /** 企业名称 */
  enterpriseName: string
  /** 所属组织名称 */
  orgName: string
  /** sid */
  sid: string
  /** 用户id */
  userId: string
  /** appid */
  appId: string
  /** homeId */
  homeId: string
  /** empId */
  empId: string
  email: string
  /** lv */
  lv: number | string
  /** messageLv */
  messageLv: number | string
  /** operationList */
  operationList: OperateType[]
  /** 其他用户信息列表 */
  otherUserInfoList: IOtherUsersInfo[]
  /** 用户其他信息 */
  otherUserInfo: OtherUserInfo | null
  /**
   * desc: 设置homeId
   * params: homeId
   */
  setHomeId(homeId: string): void
  /**
   * desc: 设置otherUserInfo
   * params: otherUserInfo
   */
  setOtherUserInfo(info: OtherUserInfo | null): void
  /**
   * desc: 查询消息时间戳
   * params: rv
   */
  setLv(lv: number): void
  /**
   * desc: 银行破产登陆信息
   * params: rv
   */
  updateBankSdkLoginInfo(sid: string, userId: string): void
  /**
   * desc: 口令直播登陆信息
   * params: rv
   */
  updateTouristLiveLoginInfo(
    sid: string,
    userId: string,
    userName: string
  ): void
  /**
   * desc: 进入消息列表时间戳
   * params: messageLv
   */
  setMessageLv(messageLv: number): void
  /**
   * desc: 增值服务权限列表
   * params: operationList
   */
  setOperationList(operationList: OperateType[]): void
  /**
   * desc: 初始化数据
   */
  initState(): void
  setHomeNoScroll(visiable: boolean): void
  /**
   * desc: 清除定时刷新sid
   */
  clearRefreshSidTask(): void
  /**
   * desc: 加载在登陆信息
   */
  loadLoginInfo(): Promise<any>
  /**
   * desc: 其他用户信息
   */
  loadOtherUserInfo(userId: string): void
  /** 更新用户信息 */
  updateUserInfo(userName: string, nickName: string, avatar: string): void
  /** 根据key名更新用户store */
  updateUserKey(key: string, value: string | number): void
  /**
   * desc: 更新用户登录信息
   * enterpriseId：企业id
   * enterpriseName：企业名称
   * sid：sid
   * userId：用户id
   * appId：qppid
   */
  updateLoginInfo(
    enterpriseId: string,
    enterpriseName: string,
    sid: string,
    userId: string,
    appId?: string
  ): void
  /** 更新身份 */
  updateIdentity(enterpriseId: string, enterpriseName: string): void
  /** 设置sid */
  setSid(sid: string): void
  /** 获取sid */
  getSid: () => string
}
class UserStore implements IUserStore {
  @observable public isLogin: boolean
  @observable public empId: string
  @observable public email: string
  @observable public userName: string
  @observable public nickName: string
  @observable public avatar: string
  @observable public enterpriseId: string
  @observable public enterpriseName: string
  @observable public orgName: string
  @observable public sid: string
  @observable public userId: string
  @observable public appId: string
  @observable public homeId: string
  @observable public lv: number | string
  @observable public messageLv: number | string
  @observable public noScroll: boolean
  @observable public operationList: OperateType[]
  @observable public confirmDialogVisbile: boolean
  @observable public isLoginOverTimer: boolean
  @observable public otherUserInfoList: IOtherUsersInfo[]
  @observable public otherUserInfo: OtherUserInfo | null
  private refreshSidTimer: NodeJS.Timeout
  constructor() {
    this.initState()
  }
  @action
  public initState(): void {
    this.isLoginOverTimer = false
    this.isLogin = false
    this.nickName = ''
    this.avatar = ''
    this.enterpriseId = ''
    this.enterpriseName = ''
    this.orgName = ''
    this.sid = ''
    this.userId = ''
    this.appId = ''
    this.homeId = ''
    this.lv = ''
    this.messageLv = ''
    this.otherUserInfo = null
  }

  public getSid() {
    if (!this.sid) {
      const { sid = '' } = Store.get('sessionInfo') || {}
      return sid
    }
    return this.sid
  }

  public getUserId() {
    if (!this.userId) {
      const { userId = '' } = Store.get('sessionInfo') || {}
      return userId
    }
    return this.userId
  }

  public getEnterpriseId() {
    if (!this.enterpriseId) {
      const { enterpriseId = '' } = Store.get('sessionInfo') || {}
      return enterpriseId
    }
    return this.enterpriseId
  }

  public initStore(sessionInfo: ISessionInfo, userInfo: IUserInfo) {
    const { appId, enterpriseId, enterpriseName, sid, userId } = sessionInfo
    const { userName, nickName, userImg } = userInfo
    this.updateLoginInfo(enterpriseId, enterpriseName, sid, userId, appId)
    this.updateUserInfo(userName, nickName, userImg)
    Store.set('sessionInfo', sessionInfo)
    window.sessionStorage.setItem('__zn__sid', sid)
    Store.set('userInfo', userInfo)
  }

  @action
  public updateBankSdkLoginInfo(sid: string, userId: string) {
    this.sid = sid
    this.userId = userId
    this.getUserInfo()
  }
  @action
  public updateTouristLiveLoginInfo(
    sid: string,
    userId: string,
    userName: string
  ) {
    this.sid = sid
    this.userId = userId
    this.userName = userName
  }
  @action
  public setOtherUserInfo(info: OtherUserInfo | null): void {
    this.otherUserInfo = info
  }
  @action
  public updateLoginInfo(
    enterpriseId: string,
    enterpriseName: string,
    sid: string,
    userId: string,
    appId = '',
    email = '',
    emplId = ''
  ): void {
    this.enterpriseId = enterpriseId
    this.enterpriseName = enterpriseName
    this.sid = sid
    this.isLogin = true
    this.isLoginOverTimer = false
    this.userId = userId
    this.email = email
    this.empId = emplId

    Store.set('sessionInfo', {
      enterpriseId,
      enterpriseName,
      sid,
      userId,
      appId,
    })

    window.sessionStorage.setItem('__zn__sid', sid)

    if (appId) {
      this.appId = appId
    }

    setTimeout(() => {
      this.getOtherInfo()
      this.getUserInfo()
      this.queryUserInfoBound()
      if (!this.refreshSidTimer) {
        this.initRefreshSidTask()
        return
      } else if (this.sid !== sid) {
        this.clearRefreshSidTask()
        this.initRefreshSidTask()
      }
    }, 0)
  }
  @action
  public queryUserInfoBound = async () => {
    const res = await Setting.queryUserInfoBound(this.appId)
    if (+res.code !== 0) {
      global.$message(res.message, { variant: 'error' })
      return
    }
    this.empId = lodash.get(res, 'body.userArr[0].empId', '')
    this.orgName = lodash.get(res, 'body.userArr[0].orgName', '')
    this.email = lodash.get(res, 'body.userArr[0].virtualEmail', '')
    const userInfo = Store.get('userInfo') || {}
    if (this.empId) {
      userInfo.empId = this.empId
    }
    userInfo.orgName = this.orgName
    loginZhiniaoSilent(this.empId, this.email)
    // const hasOrg = res.body.userArr && !lodash.isEmpty(res.body.userArr);
    const { userArr = [] } = res.body
    const hasOrg = !lodash.isEmpty(userArr)
    Store.set('hasOrg', hasOrg)
    Store.set('userInfo', userInfo)
  }
  @action
  public loadOtherUserInfo = async (userId: string) => {
    if (this.otherUserInfoList.some(item => item.userId === userId)) {
      return
    }
    const res: any = await Common.othersPersonDetail(userId)
    this.otherUserInfoList = this.otherUserInfoList.concat({
      ...res.body,
      userId,
    })
  }
  @action
  public updateUserOrgAndEnterName(orgName: string, enterpriseName: string) {
    this.orgName = orgName
    this.enterpriseName = enterpriseName
  }
  @action
  public updateUserInfo(
    userName: string,
    nickName: string,
    avatar: string
  ): void {
    this.userName = userName
    this.nickName = nickName
    this.avatar = avatar
  }
  @action
  public setHomeId(homeId: string): void {
    this.homeId = homeId
    Store.set('homeId', homeId)
  }
  @action
  public setSid(sid: string): void {
    this.sid = sid
  }
  @action
  public setHomeNoScroll = (noScroll: boolean) => {
    this.noScroll = noScroll
  }
  @action
  public updateUserKey(key: string, value: string | number) {
    this[key] = value
  }
  @action
  public updateIdentity(enterpriseId: string, enterpriseName: string) {
    this.enterpriseId = enterpriseId
    this.enterpriseName = enterpriseName
  }
  @action
  public setLv(lv: number) {
    this.lv = lv
  }
  @action
  public setMessageLv(messageLv: number) {
    this.messageLv = messageLv
  }
  @action
  public setOperationList(operationList: OperateType[]) {
    this.operationList = operationList
  }
  @action
  public async loadLoginInfo() {
    const loginInfo = Store.get('sessionInfo')
    if (loginInfo) {
      const { enterpriseId, enterpriseName, sid, userId, appId } = loginInfo
      this.updateLoginInfo(enterpriseId, enterpriseName, sid, userId, appId)
    }
    const homeId = Store.get('homeId')
    if (homeId) {
      this.setHomeId(homeId)
    }
    return new Promise(resolve => {
      setTimeout(() => resolve(true), 0)
    })
  }
  @action
  public async getOtherInfo() {
    const checkRes = await Login.checkAccount()
    if (checkRes && +checkRes.code === 0) {
      if (!Store.get('otherUserInfo')) {
        this.setOtherUserInfo(checkRes.body)
        Store.set('otherUserInfo', checkRes.body)
      }
    }
  }
  @action
  public async getUserInfo() {
    const { body, code } = await Login.getUserInfo()
    if (code !== 0) {
      return
    }

    const { userName, userImg, nickName } = body
    const hashRoute = getHashRoute()

    this.updateUserInfo(userName, nickName, userImg)
    Store.set('userInfo', body)
    if (hashRoute === '' || hashRoute.startsWith('login')) {
      const history1 = createHashHistory()
      const params = getQueryParams(location.href.split('?')[1])

      // 云校分享，绑定企业身份
      if (
        hashRoute.startsWith('login') &&
        params.trainingItemId &&
        +params.itemEnterpriseFlag === 2
      ) {
        const res = await signTrainApi.updateSid(
          params.trainingItemId,
          Store.get('mobilePhone')
        )
        if (res.code !== 0) {
          return
        }
        const { enterpriseId, enterpriseName, sid, userId } = res.body || {}

        this.enterpriseId = enterpriseId
        this.enterpriseName = enterpriseName
        this.sid = sid
        this.isLogin = true
        this.isLoginOverTimer = false
        this.userId = userId

        Store.set('sessionInfo', {
          enterpriseId,
          sid,
          userId,
        })

        window.sessionStorage.setItem('__zn__sid', sid)

        // 刷新项目页面
        if (params.itemEnterpriseFlag) {
          Store.set('itemEnterpriseFlag', params.itemEnterpriseFlag)
        }
        directTo(
          history1,
          `/home/openTrainingDetail/?trainingItemId=${params.trainingItemId}`
        )
        return
      }

      directTo(history1)
    }
  }
  // 定时任务，每隔1小时刷新一次sid
  @action
  public async initRefreshSidTask() {
    Store.remove('refreshTime')
    this.refreshSidTimer = setInterval(this.refreshSid, 60 * 60 * 1000)
  }
  // 清除定时刷新sid
  @action
  public async clearRefreshSidTask() {
    Store.remove('refreshTime')
    clearInterval(this.refreshSidTimer)
  }
  private refreshSid = async () => {
    const sessionInfo = Store.get('sessionInfo')
    const refreshTime = Store.get('refreshTime')

    if (!sessionInfo) {
      return
    }

    if (refreshTime) {
      const duration = Date.now() - refreshTime
      if (duration > 60 * 60 * 2 * 1000) {
        // 间隔时间超过2小时
        this.isLoginOverTimer = true
        this.showOverTimeModal()
        return
      }
    }

    const result = await Login.refreshSid()
    if (result.code === 0) {
      Store.set('refreshTime', Date.now())
    } else if (result.code === -4) {
      this.isLoginOverTimer = true
      this.showOverTimeModal()
    }
  }

  private showOverTimeModal = () => {
    if (this.isNeedUserInfo()) {
      this.clearRefreshSidTask()
      global.$confirm({
        disableBackdropClick: true,
        okText: '确定',
        visible: true,
        onOk: toLogin,
        content: '您的账号已超时，请重新登录。',
      })
    }
  }

  private isNeedUserInfo = () => {
    if (
      ['', 'register', 'login', 'bankliveroom', 'touristlive'].indexOf(
        location.hash.split('/')[1]
      ) > -1
    ) {
      return false
    }
    return true
  }
}
export default new UserStore()
